const steps = [
  { label: 'Intelligence', desc: 'Ground reality, gathered from the field.' },
  { label: 'Insight', desc: 'Patterns made visible and meaningful.' },
  { label: 'Strategy', desc: 'The right intervention, designed precisely.' },
  { label: 'Communication', desc: 'Narratives that reach and move people.' },
  { label: 'Impact', desc: 'Measurable change in the public interest.' },
];

export default function Approach() {
  return (
    <section id="approach" className="relative w-full bg-background-50 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-grid-fine opacity-60 mask-radial-fade pointer-events-none"></div>

      <div className="relative px-6 md:px-16 lg:px-28">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-4">
          <span className="text-[10px] tracking-[0.3em] uppercase text-foreground-500 font-mono">01 / The Prabhaw Approach</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left — intro */}
          <div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-foreground-950 tracking-tight font-semibold">
              From information to{' '}
              <span className="font-deva text-primary-700">प्रभाव</span>.
            </h2>
            <p data-reveal="fade" style={{ ['--reveal-delay' as never]: '120ms' }} className="mt-6 max-w-lg text-[15px] md:text-base leading-[1.8] text-foreground-600">
              Prabhaw combines research, data and field intelligence with technology,
              strategy and communication. We do not begin with a message — we begin
              with the ground. Every solution moves through a single, disciplined
              arc: from raw information to measured impact.
            </p>

            <div data-reveal-stagger className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                { k: 'Evidence-led', v: 'Nothing we do starts with an assumption.' },
                { k: 'Field-first', v: 'Intelligence comes from people and places.' },
                { k: 'Technology-backed', v: 'Data, platforms and systems in every step.' },
                { k: 'Measured', v: 'Every effort is designed to be evaluated.' },
              ].map((it) => (
                <div key={it.k} className="stagger-child rounded-lg border border-background-200 bg-background-100/50 p-5">
                  <p className="text-xs tracking-[0.2em] uppercase text-primary-700 font-mono mb-2">{it.k}</p>
                  <p className="text-[13px] leading-[1.7] text-foreground-600">{it.v}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — the arc */}
          <div data-reveal="scale" className="relative">
            <div className="relative rounded-[24px] border border-background-200 bg-background-100/60 p-8 md:p-10 overflow-hidden">
              <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-primary-100/70 blur-3xl pointer-events-none"></div>
              <div className="relative flex flex-col">
                {steps.map((s, i) => {
                  const isLast = i === steps.length - 1;
                  return (
                    <div key={s.label} className="relative flex items-center gap-5">
                      <div className="flex flex-col items-center">
                        <span
                          className={`w-11 h-11 rounded-full flex items-center justify-center border text-sm font-mono ${
                            isLast
                              ? 'bg-accent-500 text-primary-950 border-accent-500'
                              : 'bg-background-50 text-primary-700 border-primary-200'
                          }`}
                        >
                          0{i + 1}
                        </span>
                        {!isLast && <span className="w-px flex-1 my-1 bg-gradient-to-b from-primary-300 to-primary-200" style={{ minHeight: '2.25rem' }}></span>}
                      </div>
                      <div className="flex-1 pb-2">
                        <p className={`text-lg md:text-xl tracking-wide ${isLast ? 'text-primary-800 font-semibold' : 'text-foreground-900 font-medium'}`}>
                          {s.label}
                        </p>
                        <p className="text-[13px] text-foreground-600 mt-0.5">{s.desc}</p>
                      </div>
                      {!isLast && <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center text-primary-400 mr-1 hidden md:flex"></i>}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}